import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useNotifications } from 'hooks/useNotifications';
import { useEffect } from 'react';
import { AxiosWrapper } from 'services/AxiosWrapper';
import { BookingManagerApiService } from 'services/BookingManagerApi/BookingManagerApi';
import { AllocationsItem } from 'services/BookingManagerApi/types/AllocationsResponse';


export const useAllocationMatrixQuery = (
  bookingManagerApi: BookingManagerApiService<AxiosWrapper<AxiosInstance>>,
  bookingUuid: string | undefined,
  timestamp?: string,
) => {
  const notificationOps = useNotifications();
  const queryClient = useQueryClient();

  const getAllocationMatrix = useQuery({
    queryKey: ['getAllocationMatrix', bookingUuid, timestamp],
    queryFn: async () => {
      if (!bookingUuid) {
        return;
      }
      return bookingManagerApi.getAllocationMatrix(bookingUuid, timestamp);
    },
  });

  const patchAllocationMatrix = useMutation({
    mutationKey: ['patchAllocationMatrix', bookingUuid],
    mutationFn: async (allocationsItems: AllocationsItem[]) => {
      if (!bookingUuid) {
        return;
      }
      return bookingManagerApi.patchAllocationMatrix(bookingUuid, allocationsItems);
    },
    onSuccess: () => {
      notificationOps.showSuccessNotification('Guest allocation updated successfully.');
      queryClient.resetQueries({ queryKey: ['getAllocationMatrix'] });
      queryClient.refetchQueries({ queryKey: ['getAllocationMatrix'] });
    },
    onError: () => {
      notificationOps.showErrorNotification('There was an error saving the guest allocation.');
    },
  })

  useEffect(() => {
    return () => {
      queryClient.resetQueries({ queryKey: ['getAllocationMatrix'] });
    };
  }, [queryClient]);
  
  return { getAllocationMatrix, patchAllocationMatrix };
};